import VerifiedIcon from '@/app/icons/verified'
import { cn } from '@/util/cn'
import { IProfileUser, IUser } from '@giphy/js-types'
import SmartLink from './smart-link'

type Props = { user: IUser; className?: string; alternateName?: string; noLink?: boolean; href?: string }
const Username = ({ user, noLink, className, alternateName = '', href }: Props) => {
    const userLink = href || (user as IProfileUser).profile_url || `/${user.username}`
    return (
        <SmartLink
            noLink={noLink}
            href={userLink}
            className={cn(
                'flex min-w-0 cursor-pointer items-center gap-1 text-sm font-bold text-giphyWhiteSmoke',
                className
            )}
        >
            <div className="overflow-hidden text-ellipsis whitespace-nowrap subpixel-antialiased">
                {alternateName || `@${user.username}`}
            </div>
            {user.is_verified && <VerifiedIcon className={'size-3.5 shrink-0 fill-giphyBlue'} />}
        </SmartLink>
    )
}

export default Username
